import CityPageTemplate from "../city-template/CityPageTemplate";
import { laurelConfig } from "./data";

export default function LaurelPage() {
  return <CityPageTemplate config={laurelConfig} />;
}